<template>
    <div v-if="loaded" class="container bng-promotions bng-narrow-container">
        <img src="/static/promotions/deposit-100-min.jpg" alt="Get cash">
        <h1>Deposit Bonus</h1>
        <p>Your money works for you: get a bonus every day!</p>
        <p>A daily bonus that is instantly credited to the bonus balance, equal to 100% of the amount of the initial deposit made within the specified period.</p>
        <p>Bonus is provided under certain conditions and with certain limitations that the User should comply with in order to be able to withdraw bonus funds from the account. You may be required to fulfil certain conditions in order to be able to withdraw from the account the funds obtained as a result of a successful betting involving the bonus.</p>
        <p>
            All detailed rules of the promotion can be found in 
            <a
                @click="goToBonusRules()"
                class="bng-clickable bng-underlined"
            >{{ "components.common.basement.rules.bonus-rules" | translate }}</a>.
        </p>
        <p>Good Luck!</p>
    </div>
</template>
<script>
import Vue from 'vue';
export default {
    name: 'promotions-deposit',
    data() {
        return {
            loaded: false,
        };
    },
    async created() {
        this.loaded = true;
    },
    methods: {
        async goToBonusRules() {
            await Vue.router.teleport.bonusRules();
        }
    }
}
</script>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/promotions/promotions-deposit.vue